import React from "react"

const CalcHelp = (props) => (
    <div>
        <div className="block-help-q"/>
        <div className="block-help" dangerouslySetInnerHTML={{__html: props.help}}>
        </div>
    </div>
)
export default CalcHelp